import ServiceBase from "base/baseService"

export default class ListaNcmService extends ServiceBase {

    title = "Lista de NCM"
    pluralTitle = "Listas de NCM"
    url = '/cadastro/fiscal/listancm'
    frontUrl = '/cadastro/fiscal/listancm'
    frontUrlList = '/cadastro/fiscal/listancmlist'
    primaryKey = 'codigo_linc'
    ignoredsSchemaConvertions = ['cod_tilin_linc', 'usu_atua_linc']

    prepareToFront(data = {}) {

        data.descricao_linc = data?.descricao_linc || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

    getNewlistaNcmItem(data = {}) {
        return {
            action: 'ins',
            ncm_ncli: '',
            ...data
        }
    }

    getNcmWider(list = [], ncm = '') {

        if (!ncm?.trim()) return null

        const wider = list.find(item => {
            const current = item?.ncm_ncli?.trim()
            if (!current) return false
            return ncm.length >= current.length && ncm.startsWith(current)
        })

        return wider?.ncm_ncli?.trim() || null
    }

}
